import { render, staticRenderFns } from "./micropolicyList.vue?vue&type=template&id=493e889b&scoped=true&"
import script from "./micropolicyList.vue?vue&type=script&lang=js&"
export * from "./micropolicyList.vue?vue&type=script&lang=js&"
import style0 from "./micropolicyList.vue?vue&type=style&index=0&id=493e889b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e889b",
  null
  
)

export default component.exports